import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import categoryValidation from "../utils/categoryValidation";
import { setCategory } from "../../../../store/slices/applicationManagement/managementSlice";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { CATEGORY_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { useFormik } from "formik";
import { usePostCategoryMutation } from "../../../../store";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";

const CategoryForm = () => {
  const dispatch = useDispatch();
  const { categoryDialogOpen } = useSelector((state) => state.dialogSlice);
  const { category } = useSelector((state) => state.managementSlice);
  const [postCategory, { isLoading }] = usePostCategoryMutation();
  const handleClose = () => {
    dispatch(setCategory(null));
    dispatch(closeDialog(CATEGORY_DIALOG));
  };
  const formik = useFormik({
    initialValues: {
      id: category?.id ?? 0,
      name: category?.name ?? "",
    },
    validationSchema: categoryValidation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postCategory({
          id: formik.values.id,
          name: formik.values.name,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Kategori Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  return (
    <Modal
      open={categoryDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          Kategori Kaydet
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Kategori Adı"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            autoFocus
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default CategoryForm;
